import React, { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { toast } from 'sonner';
import { Calendar } from 'lucide-react';

export default function HouseRosterTab({ house, houseId }) {
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchShifts();
  }, [houseId]);

  const fetchShifts = async () => {
    try {
      const response = await api.get(`/roster/shifts`, { params: { houseId } });
      setShifts(response.data.items || []);
    } catch (error) {
      toast.error('Failed to load roster');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center py-12"><div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full" /></div>;
  }

  return (
    <Card>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>Time</TableHead>
            <TableHead>Staff</TableHead>
            <TableHead>Participant</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {shifts.slice(0, 20).map((shift) => (
            <TableRow key={shift.id}>
              <TableCell className="font-medium">
                {shift.date ? new Date(shift.date).toLocaleDateString() : 'N/A'}
              </TableCell>
              <TableCell className="text-sm">
                {shift.start_time} - {shift.end_time}
              </TableCell>
              <TableCell className="text-sm">{shift.staff_name || 'Unassigned'}</TableCell>
              <TableCell className="text-sm">{shift.participant_name || 'N/A'}</TableCell>
              <TableCell>
                <Badge variant={shift.status === 'OPEN' ? 'destructive' : 'default'}>
                  {shift.status}
                </Badge>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {shifts.length === 0 && (
        <div className="py-12 text-center text-muted-foreground">
          <Calendar className="h-12 w-12 mx-auto mb-2 opacity-50" />
          <p>No shifts scheduled for this house</p>
        </div>
      )}
    </Card>
  );
}
